import '@jetbrains/ring-ui-built/components/style.css'
import '@qodana/blocks/lib/qodana-blocks.css'
import '@qodana/report/lib/qodana-report.css'
import { init as initSentry, reactRouterBrowserTracingIntegration } from '@sentry/react'
import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'

import './index.css'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { captureAttribution } from './services/attribution/attribution'
import { defineQodanaVersion } from './utils/defineQodanaVersion'
import { CLOUD_PACKAGE_VERSION } from './version'

const viteSentryDsn = import.meta.env.VITE_SENTRY_DSN

let environment = 'development'
if (typeof window !== 'undefined') {
	try {
		const { hostname } = window.location
		if (hostname === 'localhost') {
			environment = 'development'
		} else if (hostname === 'qodana.cloud') {
			environment = 'production'
		} else {
			environment = 'testing'
		}
	} catch {
		// ignore
	}
}

if (viteSentryDsn) {
	initSentry({
		dsn: viteSentryDsn,
		integrations: [
			reactRouterBrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
		],
		release: `cloud@${CLOUD_PACKAGE_VERSION}`,
		environment,
		tracesSampleRate: 0.2,
		// default value is  ['localhost', /^\//], we just prevent sending sentry headers to localhost
		tracePropagationTargets: [/^\//],
	})
}

// Capture user-origin signals before routing/OAuth strips the utm_* query string.
captureAttribution()

const container = document.getElementById('qodanaCloudRoot')

if (container) {
	defineQodanaVersion()

	createRoot(container).render(
		<StrictMode>
			<App />
		</StrictMode>,
	)
} else {
	throw new Error('Cannot find container for qodana cloud')
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
